import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'string-selects',
  props: {
  modelValue: {
    type: String
  },
  allUser: {
    type: Array as any,
    default: () => []
  },
  userTypeId: {
    type: String,
    default: '1'
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const realValue = computed(() => {
  return props.modelValue ? props.modelValue.split(',') : []
})

watch(() => props.userTypeId, () => {
  emits('update:modelValue', '')
})

const selectChange = (data: any) => {
  console.log('selectChange', data)
  emits('update:modelValue', data.join())
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    modelValue: realValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((realValue).value = $event)),
    placeholder: "请选择参与者",
    onChange: selectChange,
    multiple: "",
    teleported: false
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.allUser, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.nickName,
          value: item.id
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})